import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConfigManagerService } from '../../shared/services/config-manager.service';
@Component({
    standalone: false,
    selector: 'q-layout-public',
    templateUrl: './layout-public.component.html',
    styleUrls: ['./layout-public.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class LayoutPublicComponent {
    @Input() isTos: boolean;
    version: string;
    businessAppUrl: string;
    constructor(configManagerService: ConfigManagerService) {
        this.version = configManagerService.version;
        this.businessAppUrl = configManagerService.apps.business;
    }
}
